<template lang="pug">
.publicacion
	.cabecera
		.avatar
			img(:src="'/src/modulos/core/php/api/perfil/avatar.php?avatar='+ publicacion.UsuarioAvatar")
		.nombre {{publicacion.UsuarioNombre}}
		.fecha
			span {{publicacion.FechaPublicacionUnix | moment('D-M-Y')}} a las {{publicacion.FechaPublicacionUnix | moment('H:m:s')}}
			span.fa.fa-thumb-tack.ml-3.mr-3(v-if="publicacion.MantenerArriba")
			span.pl-3.pr-3(style="cursor: pointer;", @click="verMenu = !verMenu")
				span.fa.fa-ellipsis-v
			.fondoTransparente(@click="verMenu = false", v-if="verMenu")
			transition(name="aparecer")
				.menuContextual(v-if="verMenu")
					table.table.table-hover.m-0
						tbody
							tr(v-if="permisos.muro_pinear_publicaciones", @click="togglePin()")
								td
									span.fa.fa-thumb-tack
								td Fijar arriba
							tr(v-if="permisos.muro_modificar_todas || publicacion.UsuarioID === usuario.ID", @click="eliminar()")
								td
									span.fa.fa-trash
								td Eliminar

	.contenido
		.comentario(v-if="publicacion.Mensaje")
			span(style="white-space:pre-line;") {{publicacion.Mensaje}}
		contenido-multimedia(:datos="publicacion")
		contenido-encuesta(v-for="encuesta in publicacion.Encuestas", :key="encuesta.EncuestaID", :datos="encuesta", :publicacionID="publicacion.PublicacionID")
		contenido-archivo(v-if="publicacion.Archivos.length > 0", :datos="publicacion")
	.reacciones
		.m-4(@mouseover="over('like')", @mouseleave="leave('like')", @click="reaccionar('like')")
			span.reaccion.fa(:class="claseLike")
			span(v-if="numLikes > 0") ({{numLikes}})
		.m-4(@mouseover="over('dislike')", @mouseleave="leave('dislike')", @click="reaccionar('dislike')")
			span.reaccion.fa(:class="claseDislike")
			span(v-if="numDislikes > 0") ({{numDislikes}})
		.m-4(@mouseover="over('comments')", @mouseleave="leave('comments')")
			span.reaccion.fa(:class="claseComments")
			span(v-if="publicacion.Comentarios.length > 0") ({{publicacion.Comentarios.length}})
	comentarios(:datos="publicacion")
</template>

<script>
import ContenidoMultimedia from './contenidoMultimedia'
import ContenidoEncuesta from './contenidoEncuesta'
import ContenidoArchivo from './contenidoArchivo'
import Comentarios from './comentarios'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
	props: ['publicacion'],
	data () {
		return {
			claseLike: 'fa-thumbs-o-up',
			claseDislike: 'fa-thumbs-o-down',
			claseComments: 'fa-comments-o',
			verMenu: false
		}
	},
	computed: {
		numLikes () {
			return this.publicacion.Reacciones.reduce((ant, reaccion) => {
				if (reaccion.Reaccion === 'like') {
					ant++
				}
				return ant
			}, 0)
		},
		numDislikes () {
			return this.publicacion.Reacciones.reduce((ant, reaccion) => {
				if (reaccion.Reaccion === 'dislike') {
					ant++
				}
				return ant
			}, 0)
		},
		...mapGetters({
			permisos: 'permisos/permisos',
			usuario: 'session/usuario'
		})
	},
	components: {
		'comentarios': Comentarios,
		'contenido-multimedia': ContenidoMultimedia,
		'contenido-encuesta': ContenidoEncuesta,
		'contenido-archivo': ContenidoArchivo
	},
	methods: {
		togglePin () {
			const datos = {
				PublicacionID: this.publicacion.PublicacionID,
				MantenerArriba: !this.publicacion.MantenerArriba
			}
			axios.post('muro/php/api/setMantenerArriba.php', datos)
				.then(() => {
					// Recargamos
					this.$store.dispatch('muro/recargar')
					this.verMenu = false
				})
				.catch(e => {
					console.error(e.response.data.error)
				})
		},
		eliminar () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar publicación',
				mensaje: `¿Quieres eliminar esta publicación?`,
				callback: acepta => {
					if (acepta) {
						axios.post('muro/php/api/delPublicacion.php', {PublicacionID: this.publicacion.PublicacionID})
							.then(() => {
								this.$store.dispatch('muro/recargar')
								this.verMenu = false
							})
							.catch(e => {
								console.error(e.response.data.error)
							})
					}
				}
			})
		},
		over (tipo) {
			if (tipo === 'like') {
				this.claseLike = 'fa-thumbs-up text-danger'
			} else if (tipo === 'dislike') {
				this.claseDislike = 'fa-thumbs-down text-danger'
			} else if (tipo === 'comments') {
				this.claseComments = 'fa-comments text-danger'
			}
		},
		leave (tipo) {
			if (tipo === 'like') {
				this.claseLike = 'fa-thumbs-o-up'
			} else if (tipo === 'dislike') {
				this.claseDislike = 'fa-thumbs-o-down'
			} else if (tipo === 'comments') {
				this.claseComments = 'fa-comments-o'
			}
		},
		reaccionar (Reaccion) {
			const datos = {
				PublicacionID: this.publicacion.PublicacionID,
				Reaccion: Reaccion
			}

			axios.post('muro/php/api/reaccionar.php', datos)
				.then(() => {
					this.$store.dispatch('muro/actualizarPublicacion', this.publicacion.PublicacionID)
				})
				.catch(e => {
					console.error(e)
				})
		}
	}
}
</script>

<style scoped>
.publicacion {
	margin: 5px;
	margin-bottom: 30px;
	border: 1px solid #e0e0e0;
	background-color: white;
	box-shadow: 0 0 5px rgba(0,0,0,0.2);
}

.cabecera {
	position: relative;
	display: flex;
	flex-direction: row;
	background-color: #f0f0f0;
	border-bottom: 1px solid #e0e0e0;
	z-index: 10;
}
.cabecera > .avatar {
	position: relative;
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: 0;
	max-width: 40px;
	min-width: 40px;
	padding: 5px;
}
.cabecera > .avatar > img {
	position: relative;
	display: inline-block;
	height: 30px;
	width: 30px;
	border-radius: 50%;
	vertical-align: middle;
}

.cabecera > .nombre {
	position: relative;
	font-size: 1.3em;
	padding: 5px;
	flex-basis: 1;
	flex-grow: 1;
	flex-shrink: 1;
	align-content: center;
	align-items: center;
	align-self: center;
	vertical-align: middle;
	opacity: 0.6;
}

.cabecera > .fecha {
	position: relative;
	padding: 5px;
	flex-basis: 1;
	flex-grow: 1;
	flex-shrink: 1;
	font-size: 1em;
	align-content: center;
	align-items: center;
	align-self: center;
	text-align: right
}

.cabecera > .fecha > span {
	opacity: 0.4;
}

.contenido {
	position: relative;
	display: block;
	background-color: white;
}

.contenido > .comentario {
	position: relative;
	display: block;
	padding: 10px;
	color: #555555;
}
.reacciones {
	position: relative;
	display: block;
	/* background-color: #F1f1f3; */
}

.reacciones > div {
	position: relative;
	display: inline-block;
	cursor: pointer;
}

.reaccion {
	font-size: 1.3em;
	margin-right: 5px;
}

.fondoTransparente {
	position: fixed;
	display: block;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0,0,0,0);
	z-index: 9;
}
.menuContextual {
	position: absolute;
	display: block;
	text-align: left;
	right: 5px;
	top: 30px;
	border: 1px solid #e0e0e0;
	box-shadow: 0 0 10px rgba(0,0,0,0.5);
	z-index: 10;
	background-color: white;
	border-radius: 3px;
	transition: all 200ms ease-in-out;
	opacity: 1;
	transform: translateY(0);
	cursor: pointer;
}

.aparecer-enter-active, .aparecer-leave-active {
  transition: all 200ms ease-in-out;
}
.aparecer-enter, .aparecer-leave-to /* .aparecer-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(-20px);
}
</style>




// WEBPACK FOOTER //
// src/modulos/muro/vue/componentes/publicacion/publicacion.vue